import React from 'react';
import ThemeCardItem from './ThemeCardItem';

const ThemeCardItems = ({ category, items }) => (
  items.map((item) => (
    <ThemeCardItem
      key={`themes_list_item_${item.id}`}
      category={category}
      theme={item}
    />
  ))
);

export default ThemeCardItems;
